module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-box-b74ec433ad01fac09cfd4b47a38ea1f7.svg";